import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { getConsentStatus, setConsent, initConsentOnLoad } from '../lib/consent';
import { Shield, X } from 'lucide-react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [checkoutActive, setCheckoutActive] = useState(false);

  useEffect(() => {
    const onCheckout = (e) => setCheckoutActive(!!e.detail);
    window.addEventListener('cp-checkout-active', onCheckout);
    return () => window.removeEventListener('cp-checkout-active', onCheckout);
  }, []);

  useEffect(() => {
    // Charge le pixel automatiquement si consentement déjà donné précédemment
    initConsentOnLoad();
    // Affiche la bannière uniquement si aucun choix n'a été enregistré
    const open = () => setVisible(true);
    window.addEventListener('cp-open-consent', open);
    if (!getConsentStatus()) {
      // Petit délai pour ne pas perturber le LCP
      const t = setTimeout(() => setVisible(true), 600);
      return () => { clearTimeout(t); window.removeEventListener('cp-open-consent', open); };
    }
    return () => window.removeEventListener('cp-open-consent', open);
  }, []);

  const handleAccept = () => {
    setConsent('accepted');
    setVisible(false);
  };

  const handleReject = () => {
    setConsent('rejected');
    setVisible(false);
  };

  if (!visible || checkoutActive) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] p-2 sm:p-3 animate-fade-in pointer-events-none"
      role="dialog"
      aria-live="polite"
      aria-label="Consentement cookies"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-2xl sm:max-w-lg mx-auto sm:mx-0 sm:ml-3 bg-white border border-slate-200 rounded-xl shadow-lg px-3 py-2.5 pointer-events-auto">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
          <Shield className="h-4 w-4 text-emerald-600 flex-shrink-0 hidden sm:block" aria-hidden="true" />
          <p className="flex-1 min-w-[200px] text-xs text-slate-600 leading-snug">
            <span className="font-semibold text-slate-900">Cookies</span> — sans votre accord, seules des visites anonymes sont comptées (aucun cookie).{' '}
            <Link
              to="/politique-cookies"
              className="underline text-emerald-700 hover:text-emerald-800 font-medium"
              data-testid="cookie-policy-link"
            >
              En savoir plus
            </Link>
          </p>
          <div className="flex gap-1.5 flex-shrink-0 ml-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={handleReject}
              className="h-9 px-3 text-xs"
              aria-label="Refuser les cookies de mesure"
              data-testid="cookie-reject-btn"
            >
              <X className="h-3.5 w-3.5 mr-1" aria-hidden="true" />
              Refuser
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="h-9 px-3 text-xs bg-emerald-600 hover:bg-emerald-700"
              aria-label="Accepter les cookies de mesure"
              data-testid="cookie-accept-btn"
            >
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
